<template>
  <div class="nettdoc-checkbox-list">
    <ul>
      <li v-for="(entry, index) in data" class="nettdoc-checkbox-list__item" :key="index+randomId">
        <input 
          type="checkbox" 
          :id="entry+index+randomId" 
          :value="entry"
          :checked="selected.includes(entry)"
          @change="e => select(e.target.value)"
          >
        <label :for="entry+index+randomId"></label>
        <span 
          class="nettdoc-checkbox-list__item--label"
          :style="selected.includes(entry) ? 'color: black' : ''"
        >{{$t(entry)}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    name: 'CheckboxList',
    data() {
      return {
        selected: this.choice || [],
        randomId: Math.floor(Math.random() * (1000 - 1)) + 1
      }
    },
    props: {
        data: Array,
        choice: Array
    },
    methods: {
      select: function(value) {
        if (this.selected.includes(value)) {
          const index = this.selected.indexOf(value)
          this.selected.splice(index,1)
        } else {
          this.selected.push(value)
        }
        this.$emit('action', this.selected)
      }
    }
}
</script>

<style lang="scss" scoped>
  .nettdoc-checkbox-list {
    box-sizing: border-box;
    min-height: 60px;
    ul {
      position: relative;
      list-style: none;
      display: grid;
      grid-template-columns: 100%;
      padding-left: 6px;
    }
    &__item {
      font-size: 16px;
      font-weight: bold;
      color: var(--cool-grey);
      margin: 10px;
      position: relative;
      &--label {
        position: absolute;
        top: 4px;
        margin-left: 10px;
      }
    }
    input[type=checkbox] {
      display: none
    }
    input[type=checkbox] + label {
      display: inline-block;
      padding: 0 0 0 0px;
      background:url("../assets/checkbox-null.svg") no-repeat;
      height: 24px;
      width: 24px;;
      cursor: pointer;
    }
    input[type=checkbox]:focus + label {
      background:url("../assets/checkbox-focus.svg") no-repeat;
    }
    input[type=checkbox]:checked + label {
      display: inline-block;
      padding: 0 0 0 0px;
      background:url("../assets/checkbox-check.svg") no-repeat;
      height: 24px;
      width: 24px;;
    }
  }
</style>